import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const RadioButton = ({
  data,
  onChangeHandler,
  currentValue,
  name,
  cypress
}) => {
  return (
    <label className="search-radio-container" data-cy="radio-container">
      <input
        type="radio"
        name={name}
        className="search-radio input-hidden"
        value={data.id}
        checked={currentValue === data.id}
        onChange={onChangeHandler}
        data-cy={`${cypress}-${data.id}`}
      />
      <div className="search-radio__text" data-cy={cypress}>
        {data.name}
      </div>
      <span className="search-radio__mark" />
    </label>
  );
};

RadioButton.propTypes = {
  data: PropTypes.object,
  onChangeHandler: PropTypes.func,
  currentValue: PropTypes.string,
  name: PropTypes.string,
  cypress: PropTypes.string
};

export default RadioButton;
